import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../../config/api';

const useSavedCandidates = () => {
    const [savedCandidates, setSavedCandidates] = useState([]);

useEffect(() => {
    const fetchCandidates = async () => {
      try {
        const response = await axios.get(getApiUrl(`/hirewithus/sc`), {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('company_token')}`
          }
        });
        const {data} = response;
        setSavedCandidates(data.savedCandidates);
      } catch (error) {
        console.error('Failed to fetch company ID:', error);
      }
    };

    fetchCandidates();
  }, []);

    return savedCandidates;
}

export default useSavedCandidates;
